import React from "react";
import "./assets/css/App.css";
import WhatsAppButton from "./components/WhatsAppButton";
import HeroSection from "./components/HeroSection";

import FAQ from "./components/Faq";
import ProductList from "./components/ProductCard";
import ProductCategory from "./components/ProductCategory";
import FeatureSection from "./components/FeatureSection";

function Home() {
  return (
    <>

      <HeroSection />
      <ProductList />
      <ProductCategory />
      <WhatsAppButton />
      <div className="relative bg-gradient-to-r from-gray-800 via-black to-gray-800 text-white text-center py-8 shadow-lg">
        <p className="text-2xl font-semibold tracking-wide">
          Verileriniz Güvende <span className="text-orange-500">reklam</span>
        </p>
        <p className="mt-2 text-sm text-gray-400">text kısmı</p>

        {/* Banner altında bir buton veya CTA eklemek isterseniz */}
        <div className="mt-4">
          <button className="bg-orange-500 text-white px-6 py-2 rounded-lg text-sm font-medium shadow-md hover:bg-orange-600 transition">
            yazı kısmı
          </button>
        </div>

        {/* Üstte süslemek için şekil veya gradient */}
      </div>
      <div className="relative bg-gradient-to-r from-gray-800 via-black to-gray-800 text-white text-center py-8 shadow-lg border">
        <p className="text-2xl font-semibold tracking-wide p-10 ">blok 1</p>
      </div>
      <div className="bg-gradient-to-r from-gray-800 via-black to-gray-800"></div>
      <div className="relative bg-gradient-to-r from-gray-800 via-black to-gray-800 text-white text-center py-8 shadow-lg border">
        <p className="text-2xl font-semibold tracking-wide p-10">blok 2</p>
      </div>

      <FeatureSection />
      <FAQ />
    </>
  );
}

export default Home;
